import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';

import { Controllers } from '@shared/core/controllers';

import { Observable } from 'rxjs';

import { AuthTypeComponent } from '../auth-type.shared.component';

@Component({
    selector: 'shared-auth-for-forgot-password-sent',
    templateUrl: './auth-for-forgot-password-sent.shared.component.html',
    styleUrls: ['./auth-for-forgot-password-sent.shared.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuthForForgotPasswordSentComponent extends AuthTypeComponent implements OnInit {
    @Input() public preHeaderMarginTop: OLO.Components.MARGIN_SIZE = 'sm';
    public email$: Observable<string>;

    constructor(
        public controllers: Controllers,
    ) {
        super(controllers);
    }

    ngOnInit(): void {
        this.email$ = this.controllers.members.getObfuscatedForgotEmail$();
    }
}
